module.exports = __webpack_public_path__ + "static/img/3_5_2.82f44891.jpg";